import React from 'react';
import classNames from 'classnames';
import Svg from '@justgiving/svg';
import { refreshIcon } from '@justgiving/icons';
import styles from './Refresh.scss';
import { useTranslation } from 'react-i18next';

interface ErrorFallbackProps {
  buttonLabel?: string;
  className?: string;
  displayRefreshButton?: boolean;
  onRefresh?: () => void;
}

const Refresh: React.FunctionComponent<ErrorFallbackProps> = ({
  buttonLabel,
  children,
  className,
  displayRefreshButton = true,
  onRefresh,
}) => {
  const handleRefreshClick = () => {
    onRefresh ? onRefresh() : window.location.reload();
  };

  const { t } = useTranslation('common', { useSuspense: false });

  return (
    <div className={classNames(styles.container, className)}>
      {children}
      {displayRefreshButton && (
        <button
          className={styles.button}
          onClick={handleRefreshClick}
          aria-label={buttonLabel ?? t('common.refresh')}
        >
          <Svg markup={refreshIcon} className={styles.icon} />
        </button>
      )}
    </div>
  );
};

export default Refresh;
